// import config from '@/config';

export default {
  menu: [
    'Edit',
    'Copy',
    'Delete',
    'Print'
  ],
  taskSelect: [
    'All tasks',
    'Done',
    'In progress'
  ],
  taskMenu: [
    'Edit',
    'Copy',
    'Delete',
    'Share',
  ],
  chips: [
    {
      title: 'จัดการข้อมูลส่วนตัว',
      url:'#/member/members',
      color: 'primaryConst',
      bgColor: [83, 103, 254]
    },
    {
      title: 'ข้อมูลการศึกษา',
      url:'#/member/members',
      color: 'warning',
      bgColor: [255, 194, 96]
    },
    {
      title: 'ผลงาน',
      url:'#/web/content_work',
      color: 'secondary',
      bgColor: [255, 92, 147]
    },
    {
      title: 'ผลงานวิชาการ',
      url:'#/web/content_work',
      color: 'warning',
      bgColor: [255, 194, 96]
    },
    {
      title: 'เว็บไซต์หลัก',
      url:'https://spss.up.ac.th/',
      color: 'successConst',
      bgColor: [60, 212, 160]
    },
  ],
  tabs: [
    {
      tabName: 'ภาพรวม',
    },
    {
      tabName: 'ผลงาน/วิจัย',
    },
    {
      tabName: 'อื่นๆ',

    },
  ],
  tabequipments: [
    {
      tabName: 'สถานะรายการยืมคืนวัสดุอุปกรณ์',
    },
  ],
  taskTabs: [
    {
      tabLink: 'today',
      tabName: 'Today',
    },
    {
      tabLink: 'week',
      tabName: 'This Week',
    },
    {
      tabLink: 'month',
      tabName: 'This Month',
    },
  ],
  buttons: ['mdi-facebook', 'mdi-basketball', 'mdi-instagram', 'mdi-github', 'mdi-twitter' ],
  tasks: {
    tasksTodayEquipment: [
      {
        time: '10:21',
        task: 'สมาชิกยกเลิกใบยืม เลขที่ B000001',
        color: 'warning',
        done: true
      },
      {
        time: '11:30',
        task: 'สมาชิกยกเลิกใบยืม เลขที่ B000002',
        color: 'primary',
        done: true
      },
      {
        time: '12:30',
        task: 'Call with PR Manager',
        color: 'warning',
        done: false
      },
      {
        time: '14:00',
        task: 'ใบยืม เลขที่ B000002 อนุมัติ',
        color: 'success',
        done: false
      },
      {
        time: '15:00',
        task: 'Call conference with a New Client',
        color: 'secondary',
        done: false
      },
      {
        time: '15:45',
        task: 'Presentation Demo Ecological Project',
        color: 'warning',
        done: false
      },
      {
        time: '16:00',
        task: 'Interview with a new UI/UX',
        color: 'primary',
        done: false
      },
      {
        time: '17:00',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: false
      }
    ],
    tasksToday: [
      {
        time: '10:21',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: true
      },
      {
        time: '11:30',
        task: 'Presentation Demo Ecological Project',
        color: 'primary',
        done: true
      },
      {
        time: '12:30',
        task: 'Call with PR Manager',
        color: 'warning',
        done: false
      },
      {
        time: '14:00',
        task: 'Interview with a new UI/UX',
        color: 'success',
        done: false
      },
      {
        time: '15:00',
        task: 'Call conference with a New Client',
        color: 'secondary',
        done: false
      },
      {
        time: '15:45',
        task: 'Presentation Demo Ecological Project',
        color: 'warning',
        done: false
      },
      {
        time: '16:00',
        task: 'Interview with a new UI/UX',
        color: 'primary',
        done: false
      },
      {
        time: '17:00',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: false
      }
    ],
    tasksWeek: [
      {
        time: '10:21',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: true
      },
      {
        time: '11:30',
        task: 'Presentation Demo Ecological Project',
        color: 'primary',
        done: true
      },
      {
        time: '12:30',
        task: 'Call with PR Manager',
        color: 'warning',
        done: false
      },
      {
        time: '14:00',
        task: 'Interview with a new UI/UX',
        color: 'success',
        done: false
      },
      {
        time: '15:00',
        task: 'Call conference with a New Client',
        color: 'secondary',
        done: false
      },
      {
        time: '15:45',
        task: 'Presentation Demo Ecological Project',
        color: 'warning',
        done: false
      },
      {
        time: '16:00',
        task: 'Interview with a new UI/UX',
        color: 'primary',
        done: false
      },
      {
        time: '17:00',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: false
      }
    ],
    tasksMonth: [
      {
        time: '10:21',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: true
      },
      {
        time: '11:30',
        task: 'Presentation Demo Ecological Project',
        color: 'primary',
        done: true
      },
      {
        time: '12:30',
        task: 'Call with PR Manager',
        color: 'warning',
        done: false
      },
      {
        time: '14:00',
        task: 'Interview with a new UI/UX',
        color: 'success',
        done: false
      },
      {
        time: '15:00',
        task: 'Call conference with a New Client',
        color: 'secondary',
        done: false
      },
      {
        time: '15:45',
        task: 'Presentation Demo Ecological Project',
        color: 'warning',
        done: false
      },
      {
        time: '16:00',
        task: 'Interview with a new UI/UX',
        color: 'primary',
        done: false
      },
      {
        time: '17:00',
        task: 'Call conference with a New Client',
        color: 'warning',
        done: false
      }
    ],
  },
  images: [
    {
      src: require('@/assets/img/user/profile/folder-blue.svg'),
      srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
      title: 'ข้อมูลส่วนตัว',
      subtitle: 'ข้อมูลพื้นฐานต่างๆ',
      url:'#/member/members'

    },
    {
      src: require('@/assets/img/user/profile/folder-pink.svg'),
      srcDark: require('@/assets/img/user/profile/folder-dark-pink.svg'),
      title: 'ข้อมูลการศึกษา',
      subtitle: 'วุฒิ/สถานศึกษา',
      url:'#/member/members'
    },
    {
      src: require('@/assets/img/user/profile/folder-yellow.svg'),
      srcDark: require('@/assets/img/user/profile/folder-dark-yellow.svg'),
      title: 'ผลงาน',
      subtitle: 'ผลงาน/งานวิจัย',
      url:'#/web/content_work'
    },
    {
      src: require('@/assets/img/user/profile/folder-green.svg'),
      srcDark: require('@/assets/img/user/profile/folder-dark-green.svg'),
      title: 'อื่นๆ',
      subtitle: 'ข้อมูลอื่นๆ',
      url:'#/app/profile-view'
    },
  ],
  select: ['ทั้งหมด'],
  sel: 'Daily',
  sel0: 'Daily',
  sel1: 'Daily',
  sel2: 'All tasks',
  selNew: 'Daily',
};
